import {Component, OnDestroy, OnInit} from '@angular/core';
import {Categoria} from '../../modelo/producto/categoria';
import {SubscriptionLike} from 'rxjs';
import {ProductoService} from '../../servicios/producto/producto.service';
import {OwlOptions} from 'ngx-owl-carousel-o';
import {CarIndexService} from '../../servicios/soporte/car-index.service';
import {CarIndex} from '../../modelo/soporte/car-index';
import {$CARET} from "codelyzer/angular/styles/chars";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit,OnDestroy {

  public categorias:Categoria[]
  public carindex:CarIndex[];
  public optionsDefault: OwlOptions;


  private subs:SubscriptionLike[];

  constructor(private productoSv:ProductoService,private carruselSV:CarIndexService) {
    this.categorias=[];
    this.subs=[];
    this.carindex=[];
    this.optionsDefault = {
      items: 1,
      loop: true,
      mouseDrag: true,
      touchDrag: false,
      pullDrag: false,
      navSpeed: 700,
      navText: [],
      nav: false,
      rewind: true,
      dots: false,
      autoplay: true,
      autoplayTimeout: 6000,
      smartSpeed: 500,
      autoWidth: true,
      margin:0
    };
  }

  ngOnInit() {
    this.subs.push(
      this.productoSv.listarCategoriasWeb().subscribe(res=>{
        this.categorias=res.data;
      })
    );
    this.subs.push(
      this.carruselSV.listarCarIndexHab().subscribe(res=>{
        this.carindex=res.data;
      })
    );
  }

  public setShow(show:boolean,categoria: Categoria): void {
    categoria.show= show;
  }

  ngOnDestroy(): void {
    this.subs.forEach(s=>s.unsubscribe());
  }

}
